import React, { useMemo } from 'react'
import BSForm from 'react-bootstrap/Form';
import BSFormControl from 'react-bootstrap/FormControl';
import { ImmutableObject } from '@hookstate/core';
import { ValidationError } from '@hookstate/validation'
import { translateValidationErrors } from '../../globalStates/utils';
import { useLanguageState } from '../../globalStates/LanguageState';
import { Branding } from '../../branding/branding';

function buildErrorMessage(errors: ImmutableObject<ValidationError[]>, branding: ImmutableObject<Branding>) {
    return translateValidationErrors(errors, branding)
}

interface FeedbackFieldProps {
    validate: () => ImmutableObject<ValidationError[]>
}

const FeedbackField: React.FC<FeedbackFieldProps> = ({ validate }) => {
    const branding = useLanguageState().getStrings()
    const validationErrors = validate()
    const error = useMemo(() => buildErrorMessage(validationErrors, branding), [branding, validationErrors])
    return (
        <BSForm.Group className='invalid-group'>
            <BSFormControl.Feedback type="invalid" style={{ display: error ? 'block' : 'none' }}>{error}</BSFormControl.Feedback>
        </BSForm.Group>
    )
}

export default FeedbackField
